import classnames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { Sidebar } from '../../entities/Sidebar';
import { EDU, MAKER, PRO } from '../../utils/constants';
import { getIcon } from '../Icons/HardwareBoards';
import './ArduinoBoards.scss';
import { Swiper, SwiperSlide } from 'swiper/react';

export interface ArduinoBoardsProps {
  boardData: Array<Sidebar>;
  type: string;
}

function isInside(board: Sidebar, type: string) {
  if (
    (type === MAKER && board.businessUnit === MAKER) ||
    (type === PRO && board.businessUnit === PRO) ||
    (type === EDU && board.businessUnit === EDU)
  ) {
    return true;
  }

  return false;
}

export default function ArduinoBoards(props: ArduinoBoardsProps): React.ReactElement {
  const { boardData, type } = props;
  const [selectedBoard, setSelectedBoard] = useState(0);

  return (
    <>
      <div className="arduino-boards">
        <div className="arduino-boards__label-container">
          <div
            className={classnames('arduino-boards__label', {
              'arduino-boards__label--maker': type === MAKER,
              'arduino-boards__label--pro': type === PRO,
              'arduino-boards__label--edu': type === EDU,
            })}
          >
            {type === MAKER ? 'For Makers' : type === PRO ? 'For Professionals' : 'For Schools'}
          </div>
          <span />
        </div>

        <div className={'arduino-boards__content'}>
          <div className="arduino-boards__boards">
            {boardData
              .filter((board) => isInside(board, type))
              .map((typeBoard, i: number) => {
                return (
                  <div
                    className={classnames('arduino-boards__box', {
                      'arduino-boards__box--selected': selectedBoard === i,
                    })}
                    key={typeBoard.firstLevelCategory}
                    onClick={() => setSelectedBoard(i)}
                  >
                    {typeBoard.firstLevelCategory === 'Kits' ? (
                      <GatsbyImage
                        alt={typeBoard.firstLevelCategory + ' image'}
                        className="arduino-boards__image"
                        image={getImage(typeBoard.image[0].node)}
                      />
                    ) : (
                      <div className="arduino-boards__image">{getIcon(typeBoard.firstLevelCategory)}</div>
                    )}
                    <h5>{typeBoard.firstLevelCategory}</h5>
                  </div>
                );
              })}
          </div>
          <div className="arduino-boards__columns">
            {boardData
              .filter((board) => isInside(board, type))
              .map((typeBoard, i: number) => {
                return selectedBoard === i ? (
                  <div className="arduino-boards__categories" key={selectedBoard}>
                    {typeBoard.nestedCategories.map((category) => {
                      return (
                        <div key={selectedBoard + ' ' + category.category} className="arduino-boards__categories--item">
                          <h5>{category.category}</h5>
                          {category.nestedChildren.map((link) => {
                            if (link) {
                              return (
                                <a key={link.title + ' ' + link.url} href={link.url}>
                                  {link.title}
                                </a>
                              );
                            } else return null;
                          })}
                        </div>
                      );
                    })}
                  </div>
                ) : null;
              })}
          </div>
        </div>
      </div>
      <div className="arduino-boards-mobile">
        <div className="arduino-boards-mobile__label-container">
          <div
            className={classnames('arduino-boards-mobile__label', {
              'arduino-boards-mobile__label--maker': type === MAKER,
              'arduino-boards-mobile__label--pro': type === PRO,
              'arduino-boards-mobile__label--edu': type === EDU,
            })}
          >
            {type === MAKER ? 'For Makers' : type === PRO ? 'For Professional' : 'For Schools'}
          </div>
          <span />
        </div>

        <div className={'arduino-boards-mobile__content'}>
          <Swiper
            spaceBetween={0}
            slidesPerView={3}
            initialSlide={1.5}
            grabCursor={true}
            watchOverflow={true}
            centeredSlides={true}
            direction={'horizontal'}
            loop={false}
            className={'arduino-boards-mobile__swiper-header'}
          >
            {boardData
              .filter((board) => isInside(board, type))
              .map((typeBoard, i: number) => {
                return (
                  <SwiperSlide key={typeBoard.firstLevelCategory}>
                    <div
                      className={classnames('arduino-boards-mobile__box', {
                        'arduino-boards-mobile__box--selected': selectedBoard === i,
                      })}
                      onClick={() => setSelectedBoard(i)}
                    >
                      {typeBoard.firstLevelCategory === 'Kits' ? (
                        <GatsbyImage
                          alt={typeBoard.firstLevelCategory + ' image'}
                          className="arduino-boards-mobile__image"
                          image={getImage(typeBoard.image[0].node)}
                        />
                      ) : (
                        <div className="arduino-boards-mobile__image">{getIcon(typeBoard.firstLevelCategory)}</div>
                      )}
                      <h5>{typeBoard.firstLevelCategory}</h5>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
          <Swiper
            className={'arduino-boards-mobile__slider'}
            spaceBetween={0}
            slidesPerView={2}
            grabCursor={true}
            watchOverflow={true}
            centeredSlides={true}
            direction={'horizontal'}
            loop={false}
          >
            <div className="arduino-boards-mobile__columns">
              {boardData
                .filter((board) => isInside(board, type))
                .map((typeBoard, i: number) => {
                  return selectedBoard === i ? (
                    <div className="arduino-boards-mobile__categories" key={selectedBoard}>
                      {typeBoard.nestedCategories.map((category) => {
                        return (
                          <SwiperSlide key={selectedBoard + ' ' + category.category}>
                            <div className="arduino-boards-mobile__categories--item">
                              <h5>{category.category}</h5>
                              {category.nestedChildren.map((link) => {
                                return (
                                  <a key={link.title + ' ' + link.url} href={link.url}>
                                    {link.title}
                                  </a>
                                );
                              })}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </div>
                  ) : null;
                })}
            </div>
          </Swiper>
        </div>
      </div>
    </>
  );
}
